// Domain Model
import { File } from ".";

export class Business {
  constructor(data = {}) {
    this.id = data.id;
    this.name = data.name;
    this.taxId = data.tax_id;
    this.websiteUrl = data.website_url;
    // BusinessDTO sends reviewed_by/reviewed_at — there is no verified_at or
    // declined_at on the entity, so the old mappings were always undefined.
    this.reviewedBy = data.reviewed_by;
    this.reviewedAt = data.reviewed_at;
    this.paymentInformation = data.payment_information;
    this.proofDocument = new File(data.proof_document);
    // The proof document object is private — proofDocument.url identifies it
    // (and is what the update form sends back) but will not open. This is the
    // short-lived presigned URL to actually view it with.
    this.proofDocumentViewUrl = data.proof_document_view_url;
    this.verificationStatus = data.verification_status;
  }
}
